import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodReportEvent from "./AbstractPeriodReportEvent.js";

/**
 * A `ViewEvent` is logged each time a published period report is viewed by any user.
 */
export default class ViewEvent extends AbstractPeriodReportEvent {
	isView() {
		return true;
	}

	isViewedByCompanyUser() {
		return this._author.isCompanyUser();
	}

	getLabel() {
		return _("Viewed");
	}

	static getType() {
		return "View";
	}
}
